<template>
  <div>

    <Drawer title="司机手册" width="600" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Card style="margin-top: 5px">

        <Form ref="editForm" :label-width="100" :model="formData">

          <!-- 
          <FormItem label="父级" prop="pid">
            <template>
              <div>
                <treeselect
                    :multiple="false"
                    :options="options"
                     v-model="formData.selected"
                    placeholder="请选择父级"/>
              </div>
            </template>

</FormItem> -->
          <FormItem label="标题" prop="title">
            <Input v-model="formData.title" placeholder="" maxlength="20"></Input>
          </FormItem>


          <!-- <FormItem label="内容" prop="content">

            <template>
              <div>
                <editor-vue ref="child"
                    :content="formData.content"
                    :readOnlys="readOnlys"
                    @changeData="hChangeData"
                    @uploadImg="hUploadImg"
                />
              </div>
            </template>
          </FormItem> -->

          <FormItem label="视频" prop="file_url">

            <Upload :before-upload="handleUpload" action="https://oil.scsasy.com/admin/Common/uploadFile">
              <Button icon="ios-cloud-upload-outline">Select the file to upload</Button>
            </Upload>
            <div v-if="file !== null">Upload file: {{ file.name }} <Button type="text" @click="upload"
                :loading="loadingStatus">{{
                  loadingStatus ? '正在上传' : '确认上传' }}</Button></div>
            <!-- 新增：已上传视频预览 -->
            <div v-if="uploadedFile">
              <p>已上传视频：</p>
              <video v-if="uploadedFile.type === 'video'" :src="uploadedFile.url" controls style="max-width: 100%;"></video>
              <img v-else-if="uploadedFile.type === 'image'" :src="uploadedFile.url" alt="已上传图片" style="max-width: 100%;" />
            </div>
          </FormItem>

          <FormItem label="排序" prop="status">
            <InputNumber :max="99999" :min="0" v-model="formData.sort" value="0"></InputNumber>
          </FormItem>
          <FormItem label="状态" prop="status">
            <i-switch v-model="formData.status" size="large" :true-value="1" :false-value="-1" false-color="red">
              <span slot="open">正常</span>
              <span slot="close">禁用</span>
            </i-switch>
          </FormItem>
          <FormItem label="是否展开文档" prop="expand" style="margin-bottom: 40px;">
            <i-switch v-model="formData.expand" size="large" :true-value="1" :false-value="-1" false-color="red">
              <span slot="open">展开</span>
              <span slot="close">不展开</span>
            </i-switch>
          </FormItem>



          <div class="drawer-footer">
            <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
            <Button type="primary" @click="doSubmit">确定</Button>
          </div>
        </Form>

      </Card>



    </Drawer>
  </div>
</template>

<script>
import config from '@/config/base-config'
// import editorVue from "@/components/wangeditor/editorVue"
import axios from 'axios'
// import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: "hedit",
  components: {
    // editorVue,
    // Treeselect
  },
  props: {
    showEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }

  },
  data() {
    return {
      apiPath: config.API_PATH,
      formData: {
        id: this.id,
        title: '',
        content: '',
        status: 1,
        expand: 0,
        sort: 1,
        type: 1,//司机端手册
        file_url: '',
        selected: '0' // 或者一个初始选中的数组，例如：[2] 表示选中 id 为 2 的选
      },
      baseInfo: {},
      proofs: [],
      readOnlys: false,
      options: [
        {
          id: 0,
          label: '顶级',
        },
      ],
      file: null,
      loadingStatus: false,
      uploadedFile: null,
      // options: [
      //   {
      //     id: 1,
      //     label: 'Option 1',
      //     children: [
      //       {id: 2, label: 'Option 1-1'},
      //       {id: 3, label: 'Option 1-2'}
      //     ]
      //   },
      //   {id: 4, label: 'Option 2'}
      // ],


    }
  },
  methods: {
    HchangeContent(editDataHtml) {


      this.$refs.child.onSetHtml(editDataHtml);
      // 获取最新的html数据
      // this.formData.content = editDataHtml
      // console.log(editDataHtml)
    },
    hChangeData(editDataHtml) {
      // 获取最新的html数据
      this.formData.content = editDataHtml
      // console.log(this.formData.content)
    },
    async hUploadImg(file, insertFn) {

      // 插入图片，调接口返回图片url,通过插入conteng

      const form = new FormData()
      form.append('image', file)
      try {
        var apiUrl = this.apiPath + 'admin/Common/uploadImage'
        const { data } = await axios.post(apiUrl, form)
        const url = data.data.url
        insertFn(url)
      } catch (e) {
        this.$message.error('上传出错')
      }

      // insertFn(imgUrl);

      // 设置只读
      // this.readOnlys = true;
    },

    async upload() {
      this.loadingStatus = true;

      let form = new FormData()
      form.append('file', this.file)
      var apiUrl = this.apiPath + 'admin/Common/uploadFile'
      let res = await axios.post(apiUrl, form)
      console.log(res.data.data.url)
      setTimeout(() => {
        this.formData.file_url = res.data.data.url;
        this.file = null;
        this.loadingStatus = false;
      }, 1000);
      console.log(this.formData.file_url)
    },

    cancelEdit() {
      this.$emit('cancel-edit')
    },
    async doSubmit() {
      let _self = this;
      // this.formData['proofs'] = this.proofs
      // this.formData['id'] = this.id
      let res = await this.$commonFun.postProxy('admin/manual/edit', _self.formData)
      //编辑成功刷新父页面
      this.$commonFun.dealApiResult(res, () => {

        // _self.$commonFun.successTip(res.msg)
        _self.$emit('edit-success')
        this.$emit('cancel-edit')
        this.$parent.reload()

      })
    },

    async getInfo() {
      let _self = this;
      let res = await this.$commonFun.postProxy('admin/manual/details', _self.formData)
      _self.$commonFun.dealApiResult(res, () => {
        _self.options = res.data.tree
        if(_self.id){
          _self.formData.title = res.data.data.title
          _self.formData.status = parseInt(res.data.data.status)
          _self.formData.selected = parseInt(res.data.data.pid)
          _self.formData.expand = parseInt(res.data.data.expand)
          _self.formData.sort = parseInt(res.data.data.sort)
          _self.formData.file_url = res.data.data.file_url
          // 富文本内容赋值
          if (this.$refs.child && typeof this.$refs.child.onSetHtml === 'function') {
            this.$refs.child.onSetHtml(res.data.data.content);
          }

          if (res.data.data.file_url) {
            const url = res.data.data.file_url;
            const ext = url.split('.').pop().toLowerCase();
            const videoExts = ['mp4', 'webm', 'ogg'];
            const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

            if (videoExts.includes(ext)) {
              _self.uploadedFile = {
                type: 'video',
                name: '已上传视频',
                url: url
              }
            } else if (imageExts.includes(ext)) {
              _self.uploadedFile = {
                type: 'image',
                name: '已上传图片',
                url: url
              }
            } else {
              _self.uploadedFile = null;
            }
          } else {
            _self.uploadedFile = null
          }
        }
        
      })
    },
    uploadSuccess(res, file) {
      file.url = res.data.url;
      file.name = res.data.url;
      this.proofs.push(res.data.url)
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.proofs.splice(fileList.indexOf(file), 1)
    },
    uploadError() {
      this.$commonFun.errorTip('上传失败请重试')
    },
    formatError() {
      this.$commonFun.errorTip('图片格式不正确 jpg、jpeg、png')
    },
    exceededSize() {
      this.$commonFun.errorTip('图片大小不能超过2M')
    },
    beforeUpload() {
      if (this.proofs.length > 1) {
        this.$commonFun.errorTip('最多只能上传3张图片')
        return false;
      }
    },
    seeImg(file) {
      this.$Modal.info({
        // title: title,
        width: 800,
        footerHide: true,
        content: `<img src="${file.url}" style="max-width: 500px;max-height: 500px">`
      });
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },


  },
  mounted() {
    this.getInfo()
  },


}
</script>

<style scoped lang="less">
.drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}

.info-item {
  >span:nth-child(1) {
    min-width: 100px;
    display: inline-block;
    text-align: right;
    letter-spacing: 2px;
    padding: 2px;
  }

  >span:nth-child(2) {
    display: inline-block;
    padding-left: 10px;
  }

  .important-word {
    font-weight: bold;
    color: red;
  }
}
</style>
